<script setup lang="ts">
import { TriangleAlert } from '@lucide/vue'
</script>

<template>
  <!-- RG-01 : bandeau du compte en attente, encadré en contour accent. -->
  <div class="notice" role="status">
    <TriangleAlert :size="18" :stroke-width="1.5" />
    <div>Votre compte est en attente de validation par l'administrateur.</div>
  </div>
</template>
